import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  opacity: .5;\n  margin-right: 4px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSign = styled.span(_templateObject());

var CURRENCY_SIGNS = {
  USD: '$',
  EUR: '€',
  RUB: '₽',
  BYR: 'BYR',
  CHF: 'CHF',
  CZK: 'Kč',
  GBP: '£',
  JPY: '¥',
  LVL: 'LVL',
  SEK: 'kr',
  SGD: 'S$',
  UAH: 'UAH',
  CAD: 'C$',
  AUD: 'AU$',
  KRW: '₩',
  PLN: 'zł',
  NONE: ''
};

function formatValue(value, decimalPosition) {
  return value.toFixed(decimalPosition).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

var Currency = function Currency(_ref) {
  var value = _ref.value,
      currencyCode = _ref.currencyCode,
      decimalPosition = _ref.decimalPosition,
      showSign = _ref.showSign;
  var currencySign = CURRENCY_SIGNS[currencyCode.toUpperCase()];
  var preparedValue = showSign && value > 0 ? "+".concat(formatValue(value, decimalPosition)) : formatValue(value, decimalPosition);
  return /*#__PURE__*/React.createElement("span", null, currencySign && /*#__PURE__*/React.createElement(StyledSign, null, currencySign), preparedValue);
};

Currency.propTypes = {
  value: PropTypes.number.isRequired,
  currencyCode: PropTypes.string,
  decimalPosition: PropTypes.number,
  showSign: PropTypes.bool
};
Currency.defaultProps = {
  currencyCode: 'USD',
  decimalPosition: 2,
  showSign: false
};

export default Currency;
export { CURRENCY_SIGNS };
